module.exports = __webpack_public_path__ + "static/salon-pasajeros---iluminacion-070c8a119cc82d131d32acb664ad2313.jpg";